<template>
  <el-card class="card-main">
    <el-button type="primary"
      icon="el-icon-plus"
      @click="onAdd"
      class="mb20"
      v-show="$ButtonShow('SAAS_ROL_ADD_01')"
    >新增角色</el-button>
    <el-table class="global-table" stripe v-loading="tableData.loading" :data="tableData.data">
      <el-table-column
        :label="item.label"
        :prop="item.prop"
        :min-width="item.minWidth||''"
        :show-overflow-tooltip = "item.showOverflowTooltip||false"
        v-for="(item,index) in tableData.tr"
        :key="index">
        <template slot-scope="scope">
          <template v-if="scope.column.property ==='customerType'">
            <span>{{customerType[scope.row.customerType]}}</span>
          </template>
          <span v-else>{{scope.row[scope.column.property]}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="100px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="onUpdate(scope.row.roleId)" v-show="$ButtonShow('SAAS_ROL_EDT_01')">编辑</el-button>
          <el-button v-if="scope.row.roleCatalog!=='1'" type="text" @click="onDelete(scope.row.roleId)" v-show="$ButtonShow('SAAS_ROL_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination
      @current-change="getData"
      @size-change="getData"
      :current-page.sync="page"
      :page-size.sync="size"
      :total="total">
    </GlobalPagination>
  </el-card>
</template>

<script>
export default {
  name: 'roleList',
  data () {
    return {
      tableData: {
        loading: false,
        tr: [
          {
            label: '角色名称',
            prop: 'roleName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '角色说明',
            prop: 'description',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '创建人',
            prop: 'createUserName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '创建时间',
            prop: 'createTime',
            minWidth: '150',
            showOverflowTooltip: true
          }
        ],
        data: [{}]
      },
      total: 0,
      page: 1,
      size: 10
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.tableData.loading = true
      this.$axios.get(this.$apis.system.rolePage, {
        page: this.page,
        size: this.size
      }).then((res) => {
        this.tableData.loading = false
        this.total = res.total || 0
        this.tableData.data = res.list || []
      }).catch(() => {
        this.tableData.loading = false
      })
    },
    onAdd () {
      this.$router.push({
        name: 'roleAdd',
        params: {
          orderNum: String(this.total + 1)
        }
      })
    },
    onUpdate (roleId) {
      this.$router.push({
        name: 'roleUpdate',
        params: {
          roleId: roleId
        }
      })
    },
    onDelete (id) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.roleDelete, {
          roleId: id
        }).then(() => {
          this.$message.success('删除成功')
          this.page = 1
          this.getData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
</style>
